import { Injectable, inject } from '@angular/core';

import { EventsService, SimpleEvent, VanillaEventNames } from '@frontend/vanilla/core';
import { filter } from 'rxjs';

import { NativeBridgeService } from '../../../core/services/nativeBridge/native-bridge.service';
import { UserService } from '../../../core/services/user/user.service';

@Injectable({
    providedIn: 'root',
})
export class VanillaEventsService {
    nativeBridgeService = inject(NativeBridgeService);
    userService = inject(UserService);
    eventsService = inject(EventsService);

    init() {
        this.eventsService.events
            .pipe(filter((event: SimpleEvent) => event?.eventName === VanillaEventNames.InboxOpen))
            .subscribe((event: SimpleEvent) => {
                if (event && this.userService.status) {
                    this.nativeBridgeService.handlePullToRefreshStateChange('open', 'inbox-overlay');
                }
            });
        this.eventsService.events
            .pipe(filter((event: SimpleEvent) => event?.eventName === VanillaEventNames.InboxClose))
            .subscribe((event: SimpleEvent) => {
                if (event && this.userService.status) {
                    this.nativeBridgeService.handlePullToRefreshStateChange('close', 'inbox-overlay');
                }
            });
    }
}
